module.exports = "/fonts/Trial-Proofer.svg?9a50d3a13487f6fee5aaa768a42c199b";